import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation ($project_id: String!, $data: ProjectExpenseInput!){
  upsertProjectExpense(data: $data){
    ${projectFragment}
  }
}`